import { activeSiteConfig } from "@config/site/site-config";
import type { LineItem } from "@graphql/generated/types";

export const getMoneyFromCentsAndFractions = (cents = 0, fractions = 0) => {
    if (!cents) return 0;

    return cents / Math.pow(10, fractions);
};

export const roundPrice = (price: number, method: "floor" | "ceil", quantity: number = 1) => {
    const roundingUnit = activeSiteConfig.roundingUnit;
    if (!roundingUnit) {
        return price;
    }

    const scaledRoundingUnit = roundingUnit * 100;
    const pricePerItem = quantity > 1 ? price / quantity : price;

    const roundedPricePerItem =
        method === "floor"
            ? Math.floor(pricePerItem / scaledRoundingUnit) * scaledRoundingUnit
            : Math.ceil(pricePerItem / scaledRoundingUnit) * scaledRoundingUnit;

    return quantity > 1 ? roundedPricePerItem * quantity : roundedPricePerItem;
};

export const calculateDiscount = (
    items: LineItem[],
    subTotalPrice: number,
    shippingPrice: number
) => {
    let totalPriceAfterDiscount = 0;
    items.forEach((lineItem) => {
        totalPriceAfterDiscount += roundPrice(
            lineItem.totalPrice.centAmount,
            "floor",
            lineItem.quantity
        );
    });

    return subTotalPrice - shippingPrice - totalPriceAfterDiscount;
};
